export const idle_hour_expiry = 12
export const mixpanel_token = (process.env.MIXPANEL_TOKEN) ? process.env.MIXPANEL_TOKEN : '';
export const link_contact_us = "http://www.sellsmart.com.au/contact";
export const PROPERTY_LINK_LITTLEHINGES = "https://openhouse.littlehinges.com.au/tour/";